import Bin from '@assets/icons/bin.svg'
import { Icon } from './Icon'

export const BinIcon = Icon(Bin)
